const config = {
    // basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
    // like '/berry-material-react/react/default'
    basename: '/',
    proxy: process.env.NODE_ENV === 'production' ? 'https://web.mobisan.ir' : 'http://localhost:8080',
    defaultPath: '/dashboard',
    fontFamily: `'Far.Yekan', 'B Yekan', 'Roboto', sans-serif`,
    borderRadius: 12
};

export default config;
